import { immutableEmptyArray } from '../../../lib'
import type { BaseEntity } from '../../entity/BaseEntity'
import type { HasTaxiID } from '../../entity/HasTaxiID'
import entityTypeMetaList from '../../entity/entityTypeMetaList.generated'
import type { Entity } from '../../entity/index'
import findByIdOrThrow from '../../findByIdOrThrow'
import type { HasPlayerId } from '../../player/has_player_id'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

type CargoList = Array<Entity & HasTaxiID>

export default function createCargoListGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to enter a taxi
  taxiEnt: Entity
) {
  const data = new Array(gridWidth * gridHeight)
  const entityTypeMeta = findByIdOrThrow(entityTypeMetaList, taxiEnt.etype_id)
  const transportsEntityIdList = entityTypeMeta.transports
  if (transportsEntityIdList) {
    for (let x = 0; x < gridWidth; x++) {
      for (let y = 0; y < gridHeight; y++) {
        const index = x + (y * gridWidth)
        const positionStack = grid[index]
        const list : CargoList = []
        if ((taxiEnt as BaseEntity)?.cargo?.length as number >= 0) {
          const taxiPlayerId = (taxiEnt as HasPlayerId).player_id
          for (let index = 0; index < positionStack.length; index++) {
            const cargoEnt = positionStack[index];
            if ((cargoEnt as HasPlayerId).player_id === taxiPlayerId) {
              if (cargoEnt.builtThisTurn) {
                continue
              }
              if (transportsEntityIdList.includes(cargoEnt.etype_id)) {
                list.push(cargoEnt as Entity & HasTaxiID)
              }
            }
          }
        }
        data[index] = list
      }
    }
    return data
  }
  return immutableEmptyArray as unknown as CargoList[]
}
